import messages from './visibilitat-modal-translations';
import * as $ from 'jquery';
import { VisibilitatMapaService } from './services/visibilitatMapaService';

export default {
    name: 'instamapsVisibilitatModal',
    i18n: {
        messages,
    },
    data(){
        return {
            form: {
                nom: "",
            }
        };
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
        mapa: { type: Object },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#visibilitat-modal').addClass('animate-flex-modal');
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#visibilitat-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
        canviarVisibilitatMapa: function(){
            let visibilitat = this.mapa.visibilitat;
            let visibilitatNova="";
            if (this.mapa.visibilitat==="O") {visibilitatNova="P";}
            else {visibilitatNova="O";}
            VisibilitatMapaService.changeVisibilityMap(this.mapa.businessId, visibilitatNova).then((response) => {
                if (response.status==="OK") {
                    window.dataLayer.push({
                        'event': 'changeVisibilityMap',
                        'businessid': this.mapa.businessId,
                        'visibilitat': visibilitat 
                    });
                    this.$emit('visibilitatMapOK', {businessId: this.mapa.businessId, visibilitat: visibilitat});
                    this.dismiss();
                }else{
                    this.dismiss();
                    this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                }
            }).catch(() => {
                this.dismiss();
                this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
            });
        }            
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/visibilitat-modal/visibilitat-modal.js